module.exports = {
  apiKey: 'AIzaSyDyJdU4zYy7Wn4NUa3_lrWENSX-8XxdDps',
  authDomain: 'antaa-qa-adhoc.firebaseapp.com',
  databaseURL: 'https://antaa-qa-adhoc.firebaseio.com',
  projectId: 'antaa-qa-adhoc',
  storageBucket: 'antaa-qa-adhoc.appspot.com',
  messagingSenderId: '313444772478',
};
